import { useContext, useEffect, useState } from "react";
import Nav from "../component/Nav";
import AllProduct from "../component/AllProduct";
import Footer from "../component/Footer";
import Tittle from "../component/Tittle";
import UserContext from "../context/UserContext";
import { useParams } from "react-router-dom";
import DeliveryInfoModal from "../component/DeliveryInfoModal";
import Loader from "../component/Loader"
import {
  openWhatsAppOrder,
  SINGLE_PRODUCT_WHATSAPP_PHONE,
} from "../utils/whatsappOrder";

export default function SingleProduct() {
  const [quantity, setQuantity] = useState(1);
  const { products } = useContext(UserContext);
  const [product, setProduct] = useState();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [currency, setCurrency] = useState("₦");
  
  const params = useParams();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/product/get/${params.id}`)
      .then((res) => res.json())
      .then((data) => setProduct(data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  const handleOrder = () => {
    setIsModalOpen(true);
  };

  const handleSubmitOrder = async (deliveryInfo) => {
    if (!product) return;
    openWhatsAppOrder(product, deliveryInfo, SINGLE_PRODUCT_WHATSAPP_PHONE);
  };
  const style ={
    title: {
    margin: "18px 0 14px",
    fontSize: "clamp(2rem, 5vw, 3rem)",
    lineHeight: 1.1,
    color: "#2d1b12",
  },
  subtitle: {
    margin: 0,
    maxWidth: "620px",
    color: "#5a4036",
    fontSize: "1.05rem",
    lineHeight: 1.8,
  },
  }

  return (
    <>
      <Nav />
      <DeliveryInfoModal
        product={product}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmitOrder}
      />
      <Loader loading={loading}/>
      <div className="product-page">
        <div className="product-wrapper">
          <div className="product-media-gallery">
            {product?.images?.[0] && (
              <div className="product-image-box">
                <img src={product?.images?.[0]} alt={product?.name} />
              </div>
            )}

            {product?.youtubeVideoId && (
              <div className="product-video-box">
                <div className="product-video-frame">
                  <iframe
                    src={`https://www.youtube.com/embed/${product.youtubeVideoId}`}
                    title={`${product.name} product video`}
                    className="product-video-iframe"
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            )}
          </div>

          <div className="product-details">
            <h1 style={style.title}>{product?.name}</h1>
            <p className="author" style={style.subtitle}>by {product?.author}</p>

            <div className="price-box">
              <span className="price">{currency}{product?.price}</span>
            </div>

            <p className="description" style={style.subtitle}>{product?.description}</p>

            <div className="quantity-box">
              <label>Quantity</label>
              <input
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>

            <button className="add-to-cart" onClick={handleOrder}>
              Place Order
            </button>
          </div>
        </div>
      </div>
      <div>
        <Tittle text={"You might also like"} />
        <br />
        <AllProduct items={products} />
        <br />
        <br />
      </div>
      <Footer />
    </>
  );
}
